<template>
    <el-dialog :visible.sync="visible" :title="id ? '编辑分销商' : '添加分销商'" @close="close">
        <el-form size="small" ref="formRef" :model="form" label-width="100px">
            <el-form-item
                label="分销商名称"
                prop="name"
                :rules="{
                    required: true,
                    message: '请输入分销商名称',
                    trigger: 'blur',
                }"
            >
                <el-input v-model="form.name" placeholder="请输入分销商名称" />
            </el-form-item>
            <el-form-item
                label="头像"
                prop="avatar"
                :rules="{
                    required: true,
                    message: '请选择头像',
                    trigger: 'blur',
                }"
            >
                <material-select
                    class="m-t-10"
                    v-model="form.avatar"
                    size="64"
                ></material-select>
            </el-form-item>
            <el-form-item
                label="账号"
                prop="account"
                :rules="{
                    required: true,
                    message: '请输入账号',
                    trigger: 'blur',
                }"
            >
                <el-input v-model="form.account" placeholder="请输入账号" />
            </el-form-item>
            <el-form-item
                label="密码"
                prop="password"
                :rules="{
                    required: id ? false : true,
                    message: '请输入密码',
                    trigger: 'blur',
                }"
            >
                <el-input v-model="form.password" placeholder="请输入密码" />
            </el-form-item>
            <el-form-item
                label="一级佣金比例"
                prop="first_commission_rate"
                :rules="{
                    required: true,
                    message: '请输入一级佣金比例',
                    trigger: 'blur',
                }"
            >
                <el-input
                    v-model="form.first_commission_rate"
                    placeholder="请输入一级佣金比例"
                />
            </el-form-item>
            <el-form-item
                label="二级佣金比例"
                prop="second_commission_rate"
                :rules="{
                    required: true,
                    message: '请输入二级佣金比例',
                    trigger: 'blur',
                }"
            >
                <el-input
                    v-model="form.second_commission_rate"
                    placeholder="请输入二级佣金比例"
                />
            </el-form-item>
            <el-form-item label="多点登陆" prop="multipoint_login">
                <el-switch
                    v-model="form.multipoint_login"
                    :active-value="1"
                    :inactive-value="0"
                    active-text="多点"
                    inactive-text="单点"
                ></el-switch>
            </el-form-item>
            <el-form-item label="状态" prop="disable">
                <el-switch
                    v-model="form.disable"
                    :active-value="0"
                    :inactive-value="1"
                    active-text="开启"
                    inactive-text="禁用"
                ></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" @click="handleSubmit"
                >确定</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import MaterialSelect from "@/components/material-select/index.vue";
import {
    apiDistributionDistributionAdd,
    apiDistributionDistributionEdit,
    apiDistributionDistributionDetail
} from "@/api/shop";

export default {
    components: {
        MaterialSelect,
    },
    data() {
        return {
            visible: false,
            id: null,
            form: {
                name: "",
                avatar: "",
                account: "",
                password: "",
                first_commission_rate: "",
                second_commission_rate: "",
                multipoint_login: 1,
                disable: 0,
            },
        };
    },
    methods: {
        handleSubmit() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    const api = this.id
                        ? apiDistributionDistributionEdit
                        : apiDistributionDistributionAdd;
                    let params = this.id
                        ? {
                              id: this.id,
                              ...this.form,
                          }
                        : this.form;
                    api(params).then((res) => {
                        this.visible = false;
                        this.$emit("success");
                    });
                }
            });
        },
        open(id) {
            if (id) this.id = id;
            if (this.id) {
                apiDistributionDistributionDetail({ id: this.id }).then(
                    (res) => {
                        this.form = {
                            name: res.name,
                            avatar: res.avatar,
                            account: res.account,
                            first_commission_rate: res.first_commission_rate,
                            second_commission_rate: res.second_commission_rate,
                            multipoint_login: res.multipoint_login,
                            disable: res.disable,
                        };
                        this.visible = true;
                    }
                );
            } else {
                this.visible = true;
            }
        },
        close() {
            this.id = null;
            this.form = {
                name: "",
                avatar: "",
                account: "",
                password: "",
                first_commission_rate: "",
                second_commission_rate: "",
                multipoint_login: 1,
                disable: 0,
            };
        },
    },
};
</script>
